import Flex from "@ui-kit/layout/Flex/Flex.web";
import PageMaxWidth from "@ui-kit/layout/PageMaxWidth/PageMaxWidth.web";
import HeaderDetails from "@shared/components/application/data-display/HeaderDetails/HeaderDetails.web";
import { PublicMembershipGroupSerializer } from "@shared/modules/memberships/types";
import { useIsSmallerThanSm } from "@shared/hooks/useIsSmallerThan";
import { PublicVenueSerializer } from "@app-contexts/public/features/org-profile/data/types/public-venue";
import { MembershipDetailsHeaderImage } from "./MembershipDetailsHeaderImage";
import { MembershipDetailsHeaderBadges } from "./MembershipDetailsHeaderBadges";

export interface MembershipDetailsHeaderProps {
  membershipGroupData: PublicMembershipGroupSerializer | undefined;
  venue?: PublicVenueSerializer | undefined;
  isTablet?: boolean;
  isLoading?: boolean;
  imageWidth?: number;
  imageHeight?: number;
  horizontalPadding?: string;
  columnGap?: string;
  fontSize?: "small" | "regular";
  isModal?: boolean;
}

export const MembershipDetailsHeader = ({
  membershipGroupData,
  venue,
  isTablet = false,
  isLoading = false,
  imageWidth,
  imageHeight,
  horizontalPadding = "40px",
  columnGap,
  fontSize = "regular",
  isModal = false,
}: MembershipDetailsHeaderProps) => {
  const isSmallerThanSm = useIsSmallerThanSm();

  if (!membershipGroupData) {
    return null;
  }

  return (
    <Flex direction="column" backgroundColor="bg">
      <PageMaxWidth
        // sm padding needs to match the padding in the PageMaxWidth component
        padding={{ base: "none", sm: `0 ${horizontalPadding}` }}
      >
        <HeaderDetails
          title={membershipGroupData?.name}
          imageElement={
            <MembershipDetailsHeaderImage
              membershipGroupData={membershipGroupData}
              imageWidth={imageWidth}
              imageHeight={imageHeight}
            />
          }
          badgeElement={
            <MembershipDetailsHeaderBadges
              membership={membershipGroupData}
              venue={venue}
              condensed={fontSize === "small"}
            />
          }
          isSmallerThanSm={isSmallerThanSm}
          isTablet={isTablet}
          isLoading={isLoading}
          isModal={isModal}
          columnGap={columnGap}
          fontSize={fontSize}
        />
      </PageMaxWidth>
    </Flex>
  );
};
